module.exports = __webpack_public_path__ + "img/rockstaripphonerender1_00056.676ae24.png";